import React from "react";
import {
	formatMetricValue,
	formatChangeDifference,
	formatPercentPointDifference,
	getDeltaClass,
	getTrendArrow,
} from "../../utils/formatComparisonMetric";

const ComparisonTableCell = ({
	metric,
	format = "number",
	deltaType = "number",
	positiveIsGood = true,
	currency = "USD",
	exportable = false,
	exporting = false,
	onExport,
	exportLabel,
}) => {
	if (!metric) {
		return (
			<td className="comparisonTableCell">
				<span className="comparisonTableCellValue">—</span>
			</td>
		);
	}

	const deltaClass = getDeltaClass(metric.trend, positiveIsGood);
	const deltaDisplay =
		deltaType === "points"
			? formatPercentPointDifference(metric.current, metric.previous)
			: formatChangeDifference(metric.current, metric.previous, format, currency);

	const valueNode = (
		<>
			<div className="comparisonTableCellValue">
				{formatMetricValue(metric.current, format, currency)}
				{exporting ? (
					<span className="comparisonTableCellExportHint"> …</span>
				) : null}
			</div>
			<div className={`comparisonTableCellDelta ${deltaClass}`}>
				{getTrendArrow(metric.trend)} {deltaDisplay}
			</div>
		</>
	);

	if (!exportable || typeof onExport !== "function") {
		return <td className="comparisonTableCell">{valueNode}</td>;
	}

	return (
		<td className="comparisonTableCell comparisonTableCellExportable">
			<button
				type="button"
				className="comparisonTableCellExportBtn"
				onClick={onExport}
				disabled={exporting}
				title={exportLabel || "Download metric data (XLSX)"}
			>
				{valueNode}
			</button>
		</td>
	);
};

export default ComparisonTableCell;
